import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/middleware/auth.ts"),
  guest: () => import("/app/middleware/guest.ts"),
  "not-verified": () => import("/app/middleware/not-verified.ts"),
  verified: () => import("/app/middleware/verified.ts")
}